import React from 'react';
import { RangeKeyType } from './EditableTable';

type AddLineResult = {
  setDataFunc: any,
  curListData: any,
  newData: any
} | undefined;

export interface ITableEditContextState {
  enabled: boolean, // in view mode to don't show controls
  tempEditColumnIndex: number,
  setTempEditColumnIndex: any,
  doSelectCell: boolean,
  setDoSelectCell: any,
  editRowIndex: number,
  setEditRowIndex: (x: number) => void,
  editColumnIndex: number,
  setEditColumnIndex: (x: number) => void,
  setEditRowColumnIndex: (x: number, y:number) => void,
  clearTableSelection: () => void,
  deleteLine: (rowIndex: number, deleteRange?: number[]) => boolean | Promise<boolean>,
  addLine(editRowIndex: number): AddLineResult;
  addLine(): AddLineResult;
  rowCount: number,
  data: Array<any>,
  rowRenderers: Array<any>,
  isCellLock: any,
  getCellData: any,
  getIndexOfFirstInvalidCell?: (rowIndex: number) => number | undefined,
  getIndexOfFirstInvalidCellAsync?: (rowIndex: number) => Promise<number | undefined>,
  canDeleteRow: ((rowIndex: number) => boolean) | undefined,
  canAdd: boolean | undefined,
  tableParentDivId: string,
  showTotalLineNum?: boolean,
  controlsAfterAddLineBtn: any,
  controlsBeforeAddLineBtn: any,
  lineSeqChange: ((seqUpDown: string, rowIndex: number) => void) | undefined,
  initializeFocusedCell: { dataLength: number; focus: boolean; } | undefined,
  addRowOnArrowDownInSpecialCase: ((rowIndex?: number) => number) | undefined,
  shouldConfirmBeforeDelete: ((rowIndex: number) => boolean) | undefined,
  useTableSearch: boolean,
  tableColumnLength: number,
  tableFocusOut: (() => void) | undefined,
  rangeKeyFunc: ((rowArray:number[], keyType:RangeKeyType) => void) | undefined,
}

const defaultState: ITableEditContextState = {
  enabled: false,
  tempEditColumnIndex: -1,
  setTempEditColumnIndex: () => { },
  doSelectCell: false,
  setDoSelectCell: () => { },
  editRowIndex: -1,
  setEditRowIndex: () => { },
  editColumnIndex: -1,
  setEditColumnIndex: () => { },
  setEditRowColumnIndex: () => { },
  clearTableSelection: () => { },
  deleteLine: () => false,
  addLine: () => undefined,
  rowCount: 0,
  data: [],
  rowRenderers: [],
  isCellLock: undefined,
  getCellData: undefined,
  getIndexOfFirstInvalidCell: () => undefined,
  getIndexOfFirstInvalidCellAsync: () => Promise.resolve(undefined),
  canDeleteRow: undefined,
  canAdd: undefined,
  tableParentDivId: '',
  showTotalLineNum: false,
  controlsAfterAddLineBtn: null,
  controlsBeforeAddLineBtn: null,
  lineSeqChange: undefined,
  initializeFocusedCell: undefined,
  addRowOnArrowDownInSpecialCase: undefined,
  shouldConfirmBeforeDelete: undefined,
  useTableSearch: false,
  tableColumnLength: 0,
  tableFocusOut: undefined,
  rangeKeyFunc: undefined
};

const TableEditContext = React.createContext<ITableEditContextState>(defaultState);

export default TableEditContext;
